/* OBC quick order: add every row with a quantity > 0 to the cart in one request, then open the cart. */
(function () {
  function init(root) {
    var form = root.querySelector('.obc-qo__form');
    var btn = root.querySelector('[data-obc-qo-submit]');
    var summary = root.querySelector('[data-obc-qo-summary]');
    var err = root.querySelector('[data-obc-qo-error]');
    var i18nEl = document.querySelector('[data-obc-qo-i18n]');
    var i18n = i18nEl ? JSON.parse(i18nEl.textContent) : {};
    var cartUrl = root.getAttribute('data-cart-url') || '/cart';
    var moneyFmt = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'CAD';
    var lang = document.documentElement.lang || 'en';

    function selected() {
      var out = [];
      var seen = {};
      root.querySelectorAll('.obc-qo__input').forEach(function (inp) {
        var q = parseInt(inp.value, 10);
        if (!q || q < 1) return;
        var id = inp.getAttribute('data-variant-id');
        if (seen[id]) { seen[id].quantity += q; return; }
        seen[id] = { id: parseInt(id, 10), quantity: q, price: parseInt(inp.getAttribute('data-price'), 10) || 0 };
        out.push(seen[id]);
      });
      return out;
    }
    function fmt(cents) {
      try { return new Intl.NumberFormat(lang, { style: 'currency', currency: moneyFmt, currencyDisplay: 'narrowSymbol' }).format(cents / 100); }
      catch (e) { return '$' + (cents / 100).toFixed(2); }
    }
    function update() {
      var items = selected();
      var cases = 0, total = 0;
      items.forEach(function (it) { cases += it.quantity; total += it.quantity * it.price; });
      btn.disabled = cases === 0;
      summary.textContent = cases === 0 ? i18n.none : (i18n.selected || '').replace('__C__', cases).replace('__T__', fmt(total));
    }
    root.addEventListener('focusin', function (e) { if (e.target.classList.contains('obc-qo__input')) { try { e.target.select(); } catch (x) {} } });
    root.addEventListener('input', function (e) { if (e.target.classList.contains('obc-qo__input')) update(); });
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var items = selected().map(function (it) { return { id: it.id, quantity: it.quantity }; });
      if (!items.length) return;
      btn.disabled = true;
      err.hidden = true;
      var label = btn.textContent;
      btn.textContent = i18n.adding || label;
      fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error((res.j && (res.j.description || res.j.message)) || '');
          window.location.href = cartUrl;
        })
        .catch(function (ex) {
          err.textContent = (i18n.error || '') + (ex && ex.message ? ' ' + ex.message : '');
          err.hidden = false;
          btn.textContent = label;
          btn.disabled = false;
        });
    });
    update();
  }
  document.querySelectorAll('[data-obc-qo]').forEach(init);
})();
